const ONE_HALF_CIRCLE_TYPE = "OneHalfCircleType",
  TWO_HALF_CIRCLES_TYPE = "TwoHalfCirclesType",
  TRANSPARENT_CIRCLE_TYPE = "TransparentCircleType";

export { ONE_HALF_CIRCLE_TYPE, TWO_HALF_CIRCLES_TYPE, TRANSPARENT_CIRCLE_TYPE };
